'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const ListSettingsIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M8.66667 18.1111H2M22 5.33331H2M2 11.7222H9.77778",
          stroke: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M21.1555 14.5889C21.1555 13.9889 21.5 13.4667 22 13.2222C21.7778 12.4445 21.3667 11.7445 20.8222 11.1778C20.5778 11.3445 20.2778 11.4445 19.9667 11.4445C19.1222 11.4445 18.4333 10.7556 18.4333 9.91113C18.4333 9.8778 18.4333 9.84445 18.4333 9.81112C18.0667 9.72223 17.6667 9.6778 17.2667 9.6778C16.8667 9.6778 16.4778 9.72223 16.1 9.81112C16.1 9.85556 16.1 9.90002 16.1 9.94446C16.1 10.7889 15.4222 11.4778 14.5667 11.4778C14.2444 11.4778 13.9444 11.3778 13.6889 11.2C13.1555 11.7556 12.7555 12.4445 12.5333 13.2111C13.0333 13.4667 13.3778 13.9889 13.3778 14.5778C13.3778 15.1667 13.0333 15.7 12.5333 15.9445C12.7555 16.7222 13.1667 17.4222 13.7111 17.9889C13.9555 17.8334 14.2555 17.7334 14.5667 17.7334C15.4222 17.7334 16.1 18.4222 16.1 19.2667C16.1 19.3 16.1 19.3334 16.1 19.3667C16.4667 19.4556 16.8667 19.5 17.2667 19.5C17.6667 19.5 18.0555 19.4556 18.4333 19.3667C18.4333 19.3334 18.4333 19.3 18.4333 19.2778C18.4333 18.4222 19.1111 17.7334 19.9667 17.7334C20.2778 17.7334 20.5778 17.8334 20.8222 17.9889C21.3667 17.4222 21.7778 16.7334 22 15.9556C21.5 15.7 21.1555 15.1778 21.1555 14.5889ZM17.2778 16.6111C16.1555 16.6111 15.2555 15.7 15.2555 14.5889C15.2555 13.4778 16.1667 12.5667 17.2778 12.5667C18.3889 12.5667 19.3 13.4778 19.3 14.5889C19.3 15.7 18.3889 16.6111 17.2778 16.6111Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
const VpListSettingsIcon = forwardRef(ListSettingsIcon);

export { VpListSettingsIcon as default };
